export default __webpack_public_path__ + "static/media/mud-pro.4f50fd0a.glb";